module.exports = __webpack_public_path__ + "img/产品1.ef966836.png";